import { render } from "./CreateFeaturingForm.vue?vue&type=template&id=39e0999c"
import script from "./CreateFeaturingForm.vue?vue&type=script&lang=js"
export * from "./CreateFeaturingForm.vue?vue&type=script&lang=js"

import "./CreateFeaturingForm.vue?vue&type=style&index=0&id=39e0999c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__